import {mapActions, mapGetters} from "vuex";

export default {
    computed:{
        ...mapGetters({
            userInfo:"user/getUserProfile",
        }),
    },
    methods:{
        ...mapActions({
            getIssues:'issues/fetchIssues',

        }),
      checkHasIntegration(){
          if(this.userInfo.integration){
              //برای نشان دادن قسمت ایشو سلکت
              
              if(this.userInfo.integration.redmine && Object.keys(this.userInfo.integration.redmine).length !== 0) {
                  this.$store.state.isIntegrationSet = true
                  // this.getIssues().then(r => r)
              }
      }
    },

}
}
